var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 18.355,
    viewBox: "0 0 22 18.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2148ff;}.b{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 22,
    height: 18.355,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.226,11.955.4,7.06a1.443,1.443,0,0,1,0-1.992l1.1-1.11a1.423,1.423,0,0,1,1.977,0L6.207,6.731,12.52.4A1.412,1.412,0,0,1,14.5.4l1.1,1.108a1.434,1.434,0,0,1,0,1.987L8.453,10.665a1.237,1.237,0,0,1-.152.182L7.2,11.955a1.421,1.421,0,0,1-1.977,0Z",
    transform: "translate(3 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/accept-icon.f275a6e675eafaf11ef8935ffa483f6a.svg";
export { ForwardRef as ReactComponent };